<template>
  <div class='selector' style="width:100%">
    <div class='selector-container'>
      <div class='selector-arrow selector-arrow_left' @click='prevDay'></div>
      <div class="selector-txt-container selector-txt-calendar">
        <div class='selector-txt' @click="openMiniCalendar">
          {{ getCurrentDateLinear }}
        </div>
        <el-date-picker ref="picker" v-model="valueMiniCalendar" type="date" placeholder="Pick a day"
          :picker-options="pickerOptions1" @change="miniCalDateChoosed" />
      </div>
      <div class='selector-arrow selector-arrow_right' @click='nextDay'></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'CalendarNav',
  props: {
    checkVisibility: false
  },
  data() {
    return {
      valueMiniCalendar: '',
      miniCalendarVisible: false,
      miniCalendarBlur: false,
      pickerOptions1: {
        firstDayOfWeek: 1,
        disabledDate: (time) => {
          // get Today
          let now = new Date()
          now.setHours(0, 0, 0, 0)
          // get checkedDate
          let cDate = new Date(time.getTime())

          // get if day is passed
          if (time.getTime() < now) return true

          // get if closed day
          let cD = cDate.getDay()
          if (cD === 0) cD = 7
          // get if closed day
          let close = this.getDaysIsClosed(cD, true, time.getTime())
          if (close !== undefined) return true
          // get if visible
          if (this.checkVisibility) {
            let invisible = this.getInvisibleDays.find((d) => {
              return d === cD
            })
            if (invisible !== undefined) return true
          }

          // get serivce for day and check if is passed
          let idD = cDate.getDay()
          if (idD === 0) idD = 7
          let dayLabel = this.getLabelDay(idD - 1)
          let services = this.getMainServicesForDay({ date: cDate, labelDay: dayLabel }, true)
          if (services !== undefined) {
            let nbServices = Object.entries(services).length
            let count = 0
            Object.entries(services).forEach((s) => {
              let fakeDate = {
                labelDay: dayLabel,
                day: cDate.getDate(),
                month: cDate.getMonth() + 1,
                year: cDate.getFullYear()
              }
              let locked = this.getServiceLockState(s[1].name, fakeDate)
              if (locked) count++
            })
            if (count >= nbServices) return true
          }
          return false
        }
      }
    }
  },
  mounted: function () {
    this.pushCuurentDateToMiniCalendar()
  },
  computed: {
    ...mapGetters({
      getCurrentTimestamp: 'calendar/getCurrentTimestamp',
      getTodayTimestamp: 'calendar/getTodayTimestamp',
      getCurrentDateLinear: 'calendar/getCurrentDateLinear',
      getSelectedDay: 'calendar/getSelectedDay',
      getLabelDay: 'calendar/getLabelDay',
      getClosedDays: 'newServices/getClosedDays',
      getDaysIsClosed: 'newServices/getDaysIsClosed',
      getInvisibleDays: 'newServices/getInvisibleDays',
      getMainServicesForDay: 'newServices/getMainServicesForDay',
      getServiceLockState: 'newServices/getServiceLockState'
    })
  },
  methods: {
    ...mapActions({
      moveToPreviousDay: 'calendar/moveToPreviousDay',
      moveToPreviousDayCheckBack: 'calendar/moveToPreviousDayCheckBack',
      moveToNextDay: 'calendar/moveToNextDay',
      moveToThisMonthAndDay: 'calendar/moveToThisMonthAndDay',
      showVisibilityCalendar: 'calendar/showVisibilityCalendar',
      setSelectedDayTo: 'calendar/setSelectedDayTo',
      findSelectedServiceByDay: 'newServices/findSelectedServiceByDay'
    }),
    miniCalDateChoosed: function (e) {
      this.setSelectedDayTo({ day: e.getDate(), month: e.getMonth() + 1, year: e.getFullYear() }).then((val) => {
        this.miniCalendarVisible = false
      })
    },
    openMiniCalendar: function (e) {
      if (this.miniCalendarVisible) {
        this.$refs.picker.hidePicker()
      } else {
        this.$refs.picker.showPicker()
      }
      this.miniCalendarVisible = this.$refs.picker.pickerVisible
    },
    nextDay: function () {
      this.moveToNextDay(true).then(() => {
        this.pushCuurentDateToMiniCalendar()
        this.miniCalendarVisible = false
      })
    },
    prevDay: function () {
      if (this.checkVisibility) {
        this.moveToPreviousDayCheckBack(true).then(() => {
          this.pushCuurentDateToMiniCalendar()
          this.miniCalendarVisible = false
        })
      } else {
        this.moveToPreviousDay(true).then(() => {
          this.pushCuurentDateToMiniCalendar()
          this.miniCalendarVisible = false
        })
      }
    },
    pushCuurentDateToMiniCalendar: function () {
      this.valueMiniCalendar = new Date(this.getCurrentTimestamp)
    }
  }
}
</script>

<style lang="scss"></style>
